/**
 * Regex to validate an Entity format.
 *
 * @module
 *
 */
const entityRegex = /^[a-z0-9]{2}$|^$/i;

export { entityRegex };
